import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Trash = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 100 100"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.834 33.388h-51.67a2.372 2.372 0 00-2.375 2.373v49.887a2.376 2.376 0 002.375 2.377h51.67a2.374 2.374 0 002.375-2.377V35.76a2.37 2.37 0 00-2.375-2.372zm3.17-16.036H59.402v-2.999a2.373 2.373 0 00-2.373-2.377H42.971a2.375 2.375 0 00-2.375 2.377v2.999h-19.6a2.372 2.372 0 00-2.375 2.373v6.932a2.372 2.372 0 002.375 2.373h58.008a2.37 2.37 0 002.375-2.373v-6.932a2.37 2.37 0 00-2.375-2.373z"
  }));
});
Trash.displayName = 'Trash';
export var TrashDimensions = {
  height: 100,
  width: 100
};